// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-search-input {
  display: inline-flex;
  align-items: center;
  gap: var(--admin-s3);
  width: 100%;
  padding: 0 var(--admin-s3);
  border: var(--admin-border-default);
  border-radius: var(--admin-radius-sm);
  background: var(--admin-bg-surface-1);
  transition: border-color var(--admin-transition-fast), background var(--admin-transition-fast);
}

.au-search-input--sm {
  min-height: 28px;
}

.au-search-input--md {
  min-height: 32px;
}

.au-search-input:focus-within {
  border-color: rgba(255, 255, 255, 0.2);
  background: var(--admin-bg-surface-2);
}

.au-search-input__icon {
  display: inline-flex;
  flex: 0 0 auto;
  color: var(--admin-text-muted);
}

.au-search-input__icon svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  stroke-width: 1.4;
}

.au-search-input__field {
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--admin-text-primary);
  font: inherit;
  font-size: var(--admin-text-sm);
  font-weight: var(--admin-font-weight-normal);
  outline: none;
}

.au-search-input__field::placeholder {
  color: var(--admin-text-placeholder);
}

.au-search-input__hint {
  display: inline-flex;
  flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSearchInput.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;EACnC,qCAAqC;EACrC,qCAAqC;EACrC,8FAA8F;AAChG;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":[".au-search-input {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--admin-s3);\n  width: 100%;\n  padding: 0 var(--admin-s3);\n  border: var(--admin-border-default);\n  border-radius: var(--admin-radius-sm);\n  background: var(--admin-bg-surface-1);\n  transition: border-color var(--admin-transition-fast), background var(--admin-transition-fast);\n}\n\n.au-search-input--sm {\n  min-height: 28px;\n}\n\n.au-search-input--md {\n  min-height: 32px;\n}\n\n.au-search-input:focus-within {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: var(--admin-bg-surface-2);\n}\n\n.au-search-input__icon {\n  display: inline-flex;\n  flex: 0 0 auto;\n  color: var(--admin-text-muted);\n}\n\n.au-search-input__icon svg {\n  width: 14px;\n  height: 14px;\n  stroke: currentColor;\n  stroke-width: 1.4;\n}\n\n.au-search-input__field {\n  width: 100%;\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: var(--admin-text-primary);\n  font: inherit;\n  font-size: var(--admin-text-sm);\n  font-weight: var(--admin-font-weight-normal);\n  outline: none;\n}\n\n.au-search-input__field::placeholder {\n  color: var(--admin-text-placeholder);\n}\n\n.au-search-input__hint {\n  display: inline-flex;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
